import React, { useCallback } from "react";
import { useSetAtom } from "jotai";
import { useItems } from "atoms/itemAtom";
import {
  setConfirmationModalAtom,
  setModalCloseAtom,
} from "atoms/modalAtom/modalAtom";

import { Button } from "components/Button/Button";

import { useDeleteProduct } from "../api";

export function DeleteProductButton() {
  const setConfirmationModal = useSetAtom(setConfirmationModalAtom);
  const closeModal = useSetAtom(setModalCloseAtom);
  const { itemsState, setItemsState } = useItems();

  const { mutate: deleteProduct } = useDeleteProduct();

  const onConfirm = () => {
    deleteProduct(itemsState.checkedItems[0].itemid || "", {
      onSuccess: () => {
        setItemsState((prev) => ({
          checkedItems: prev.checkedItems.filter(
            (temp) => temp.itemid !== itemsState.checkedItems[0].itemid
          ),
        }));
      },
    });
    closeModal();
  };

  const handleClick = useCallback(() => {
    if (itemsState.checkedItems.length === 1) {
      setConfirmationModal({
        title: `Вы действительно хотите удалить товар "${itemsState.checkedItems[0].name}"?`,
        onConfirm,
      });
    }
  }, [itemsState, setConfirmationModal, onConfirm]);

  return (
    <Button
      icon="delete"
      onClick={handleClick}
      disabled={itemsState.checkedItems.length !== 1}
    />
  );
}
